/**
 * Rendered marketing films. One record feeds the <MarketingFilm> player and the
 * VideoObject JSON-LD, so the two cannot disagree. Assets are rendered by
 * scripts/intro-film/render.mjs (README: "Re-render the site video").
 */
export interface Film {
  /** VideoObject name and the <video> accessible name. */
  title: string;
  /** VideoObject description. */
  description: string;
  /** Root-relative MP4 (H.264 + AAC, faststart). */
  src: string;
  /** Root-relative WebP poster; also VideoObject.thumbnailUrl. */
  poster: string;
  /** Root-relative WebVTT captions (English). */
  captions: string;
  /** Whole seconds; pinned to the film timeline by films.test.ts. */
  durationSeconds: number;
  /** ISO date the current MP4 reached production. */
  uploadDate: string;
}

const MEET_JUNE_DIR = '/marketing/intro-film/video';

export const FILMS = {
  'meet-june': {
    title: 'Meet June',
    description:
      'Everyone who loves June remembers her a little differently. Lori, Loristry’s biographer, calls each of them, listens, and weaves every voice into one book.',
    src: `${MEET_JUNE_DIR}/intro-film.mp4`,
    poster: `${MEET_JUNE_DIR}/poster.webp`,
    captions: `${MEET_JUNE_DIR}/captions.en.vtt`,
    durationSeconds: 60,
    uploadDate: '2026-09-29',
  },
} satisfies Record<string, Film>;

export type FilmId = keyof typeof FILMS;
